import z from "zod";
import { availableAuthProviders } from "../../../types/providers/auth-provider";

export const availableAuthProvidersValidator = z.object({
    AUTH_PROVIDER: z.enum(availableAuthProviders).default("microsoft"),
})

export const microsoftAuthProviderValidator = z.object({
  MICROSOFT_CLIENT_ID: z.string().min(1, "required").optional(),
  MICROSOFT_CLIENT_SECRET: z.string().min(1, "required").optional(),
  MICROSOFT_TENANT_ID: z.string().min(1, "required").optional(),
  // Group fetching settings - flexible array to support different group types
  FETCH_GROUP_TYPES: z.array(z.enum(["security", "m365", "all"])).default(["security"]).optional(),
});

export const googleAuthProviderValidator = z.object({
  GOOGLE_CLIENT_ID: z.string().min(1, "required").optional(),
  GOOGLE_CLIENT_SECRET: z.string().min(1, "required").optional(),
  // Google Workspace Admin SDK settings for group fetching
  GOOGLE_ADMIN_EMAIL: z.string().email().optional(), // Service account needs to impersonate an admin
  GOOGLE_SERVICE_ACCOUNT_KEY: z.string().optional(), // JSON key for service account
  // Group fetching settings
  FETCH_GOOGLE_GROUPS: z.boolean().default(false).optional(), // Enable Google Groups fetching
});
